import type { SVGProps } from "react";
export default function SvgCircleMinus(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-circle-minus-icon lucide-circle-minus"
			viewBox="0 0 24 24"
			{...props}
		>
			<circle cx={12} cy={12} r={10} />
			<path d="M8 12h8" />
		</svg>
	);
}
